module.exports = __webpack_public_path__ + "img/fresh.3413d22b.svg";